// extracted by mini-css-extract-plugin
export default {"root":"table_root__xSSnL","thead":"table_thead__yXCUa","td":"table_td__inoWr"};